export type {
  PatientTrackingDashboardSummary,
  PatientStatus,
  AlertResult,
  PatientTrackingStatusCounts,
  CeOpenIssueCount,
  TrackerAttentionItem,
  PatientTrackingLastAlertRun
} from '@jarvis/platform-ui/patient-tracking-dashboard';
import { fetchPatientTrackingDashboardSummary as fetchSummary } from '@jarvis/platform-ui/patient-tracking-dashboard';
import { apiFetch } from './client';

export async function fetchPatientTrackingDashboardSummary() {
  return fetchSummary(apiFetch);
}
